/*
 * • FCSE Travelsearch Sandbox 2013 •
 * 
 * © Copyright 2013, Tom Hülser [freshcells systems engineering GmbH]
 * 
 * Supports all features that jQueryUI slider component has.
 * Supports snapping to the defined values.
 * Supports snapping for ranges.
 * Allows to define a custom distribution sequence (uniform distribution is used by default).
 */
define([
    'jQuery',
    'jQueryUI'],
    function( $, jQueryUI ) {

        var defaultOptions = {
            min: 0,
            max: 100,
            range: false,
            // Array with values you want to snap to.
            snaps: null,
            // Array with values describing visual distribution for snaps.
            // If no distribution provided then uniform distribution is used.
            distribution: null
        };

        $.widget("ui.xslider", $.ui.slider, {

            options: $.extend({}, $.ui.slider.prototype.options, defaultOptions),

            _processOptions: function(options) {
                var values = options.values,
                    snaps = options.snaps;
                if (values && values.length > 2) {
                    throw new Error("Slider can handle only 2 values per range.");
                }
                if (values && values.length && values[0] >= values[1]) {
                    throw new Error("Slider's range is malformed: [" + values + "].")
                }
                if (values && snaps && (($.inArray(values[0], snaps) == -1) ||
                    ($.inArray(values[1], snaps) == -1))) {
                    throw new Error("Slider's snaps and values are not in sync: ["+snaps+"], ["+values+"].")
                }
                if (options.value && values && values.length) {
                    delete options.value;
                }
            },
            _create: function() {
                this._processOptions(this.options);
                $.ui.slider.prototype._create.apply(this, arguments);

                var min = this.options.min,
                    max = this.options.max,
                    snaps = this.options.snaps,
                    distribution = this.options.distribution,
                    uniformStep = 1,
                    values = this.options.values,
                    value = this.options.value;

                this._startOptions = null;
                this._distributionValues = [];
                this._useSnaps = false;

                if ((this._useSnaps = (snaps && snaps.length))) {
                    if (distribution && distribution.length) {
                        this._distributionValues = distribution;
                    } else {
                        uniformStep = (max - min) / (snaps.length - 1);
                        for (var i = 0; i < snaps.length; ++i) {
                            this._distributionValues.push(i * uniformStep + min);
                        }
                    }
                    if (values && values.length) {
                        for (var i = 0; i < values.length; i++) {
                            this.values(i, this._findClosest(this._snapValue(values[i])));
                        }
                    } else {
                        value = !isNaN(value) ? value : this.options.min;
                        this.value(this._findClosest(this._snapValue(value)));
                    }
                }
            },
            _start: function(event, index) {
                this._startOptions = {
                    index: index,
                    handle: this.handles[index],
                    value: this.value()
                };
                this._startOptions.value = this.options.values ? this.values(index) : this.value();
                this._startOptions.values = this.values();
                this._startOptions.current = this._startOptions.value;
                var result = $.ui.slider.prototype._start.apply(this, arguments);
                this.handles.blur();
                return result;
            },
            _slide: function(event, index, newVal) {
                if(!this._useSnaps) {
                    return $.ui.slider.prototype._slide.apply(this,arguments);
                }
                var allowed,
                    curValues = this.values(),
                    startVal = this._startOptions.value,
                    normValues = this._distributionValues,
                    closestVal = this._findClosest(newVal),
                    snapIndex,
                    snappedVal,
                    snappedValues,
                    next = newVal > startVal;

                if (this._startOptions.current == closestVal ||
                    !(Math.abs(startVal - newVal) >= Math.abs((startVal - closestVal)/2)) ||
                    (next ? curValues[index + 1] <= closestVal : curValues[index - 1] >= closestVal)) { return; }

                snapIndex = $.inArray(closestVal, normValues);
                snappedVal = this.options.snaps[snapIndex];
                snappedValues = curValues;
                snappedValues[index] = snappedVal;

                allowed = this._trigger("slide", event, {
                    handle: this.handles[index],
                    value: snappedVal,
                    values: snappedValues
                });

                if (allowed !== false) {
                    (this.options.values) ? this.values(index, closestVal) : this.value(closestVal);
                }
                this._startOptions.current = closestVal;
            },
            _trigger: function(type, event, ui) {
                if (this._useSnaps) {
                    if (type == "start" || type == "stop") {
                        ui.value = this._convert(ui.value);
                        if (ui.values) { ui.values = this._convert(ui.values);}
                    }
                }
                return $.Widget.prototype._trigger.call(this, type, event, ui);
            },
            _trimAlignValue: function(val) {
                return this._findClosest($.ui.slider.prototype._trimAlignValue.apply(this, arguments));
            },
            _snapValue: function(value) {
                if (!this._useSnaps) { return value; }

                var snaps = this.options.snaps,
                    snapIndex = $.inArray(value, snaps);

                return snapIndex != -1 ? this._distributionValues[snapIndex] : value;
            },
            _findClosest: function(value) {
                if (!this._useSnaps) { return value; }

                var result = value, prev = null, half,
                    distribution = this._distributionValues;

                if (distribution && $.inArray(value, distribution) == -1) {
                    for (var i = 0; i < distribution.length; ++i) {
                        if (prev !== null && value > prev && value < distribution[i]) {
                            half = (distribution[i] - prev) / 2;
                            result = (value - prev) > half ? distribution[i] : prev;
                            break;
                        }
                        prev = distribution[i];
                    }
                }
                return result;
            },
            _convert: function(value) {
                if (!this._useSnaps) { return value; }

                var result = [], item, distributionIndex,
                    values = $.isArray(value) ? value : [value];

                for (var i = 0; i < values.length; ++i) {
                    item = values[i];
                    if ((distributionIndex = $.inArray(item, this._distributionValues)) != -1) {
                        item = this.options.snaps[distributionIndex];
                    }
                    result.push(item);
                }
                return values === value ? result : result[0];
            },
            // Use these public methods below to get not distributed value/values from outside e.g.
            // var sliderValues = $("#slider").xslider("xvalues");
            xvalues: function(index, newValue) {
                if ($.isArray(index) && (this.options.range !== true || !this.options.values)) {
                    throw new Error("Slider is not in range mode but range given: ["+index+"].");
                }
                if (!this._useSnaps) {
                    return this.values(index, newValue);
                } else if (arguments.length > 1 || (arguments.length && $.isArray(arguments[0]))) {
                    this.values.apply(this, arguments);
                } else if (arguments.length) {
                    if (this.options.values && this.options.values.length) {
                        return this._convert(this._values(index));
                    } else {
                        return this._convert(this.value());
                    }
                } else {
                    return this._convert(this.options.range ? this._values() : this._value());
                }
            },
            xvalue: function(newValue) {
                if (!this._useSnaps) {
                    return this.value(newValue);
                } else if (arguments.length) {
                    ($.isArray(newValue)) ? this.xvalues(newValue) :
                        this.value.apply(this, arguments);
                } else {
                    return this._convert(this._value());
                }
            }
        });

});


//////////////////
// WEBPACK FOOTER
// ./~/fcse-xslider/jquery.xslider.js
// module id = 63
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21